import { Book } from "@/types/book";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Download, Star } from "lucide-react";
import { Link } from "react-router-dom";

interface BookCardProps {
  book: Book;
}

const BookCard = ({ book }: BookCardProps) => {
  return (
    <Link to={`/book/${book.id}`}>
      <Card className="book-card-hover overflow-hidden border-0 h-full gradient-card">
        <div className="aspect-[2/3] overflow-hidden bg-muted">
          <img
            src={book.coverImage}
            alt={`${book.title} cover`}
            className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
          />
        </div>
        <CardContent className="p-4">
          <Badge variant="secondary" className="mb-2 text-xs">
            {book.category}
          </Badge>
          <h3 className="font-semibold text-lg line-clamp-2 mb-1">
            {book.title}
          </h3>
          <p className="text-sm text-muted-foreground mb-2">{book.author}</p>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {book.description}
          </p>
        </CardContent>
        <CardFooter className="px-4 pb-4 pt-0 flex justify-between items-center text-sm text-muted-foreground">
          {book.rating && (
            <div className="flex items-center gap-1">
              <Star className="h-4 w-4 fill-primary text-primary" />
              <span>{book.rating.toFixed(1)}</span>
            </div>
          )}
          {book.downloads && (
            <div className="flex items-center gap-1">
              <Download className="h-4 w-4" />
              <span>{book.downloads}</span>
            </div>
          )}
        </CardFooter>
      </Card>
    </Link>
  );
};

export default BookCard;
